import React from 'react';
import { getAuthHeaderAndShopperId } from '@vp/common-api-utils';
import { useSelector } from 'react-redux';
import { PayPalMessage } from '@vp/payment-components';
import useSiteData from '../../hooks/useSiteData';
import useTracking from '../../hooks/useTracking';
import { cartItemSelectors } from '../../state/cartItems';
import type { RootState } from '../../types';
import usePricingSummary from '../../hooks/usePricingSummary';

export const PayPalMessageDisplay = () => {
  const { uiLocalization, vistacartTenant, paymentEnvironment } = useSiteData();
  const { authHeader, shopperId } = getAuthHeaderAndShopperId();
  const { trackPayPalMessageClicked } = useTracking();
  const { displayedOrderTotalCents } = usePricingSummary();
  const siteLocale = uiLocalization && uiLocalization.locale;
  const cartContainsSubscription = useSelector((state: RootState) =>
    cartItemSelectors.selectCartContainsSubscription(state)
  );

  return (
    <PayPalMessage
      authToken={authHeader}
      environment={paymentEnvironment}
      hasSubscription={cartContainsSubscription}
      locale={siteLocale}
      purchaseAmount={displayedOrderTotalCents || 0}
      shopperId={shopperId}
      tenant={vistacartTenant}
      paypalMessageOnClickHandler={(data: any) => {
        trackPayPalMessageClicked(data?.meta?.offerType);
      }}
    />
  );
};
